const layout = {
  header: {
    changeView: {
      toasts: {
        success: 'Local alterado com sucesso',
        failure: 'Ocorreu um erro inesperado',
      },
    },
  },

  sideBar: {
    menu: {
      home: {
        title: 'Home',
      },
      parents: {
        title: 'Pais',
      },
      trips: {
        title: 'Viagens',
        children: {
          trips: 'Viagens',
          timeline: 'Linha do tempo',
          feedbacks: 'Feedbacks',
        },
      },
      jobs: {
        title: 'Reservas',
        children: {
          jobs: 'Reservas',
          calendar: 'Calendário',
          passengers: 'Passageiros',
          students: 'Alunos',
          employees: 'Funcionários',
          profiles: 'Perfis',
          parents: 'Pais',
          caregivers: 'Cuidadores',
        },
      },
      drivers: {
        title: 'Motoristas',
        children: {
          drivers: 'Motoristas',
          onlineDrivers: 'Motoristas on-line',
          driverShifts: 'Turnos do motorista',
          driverShiftsTemplates: 'Modelos de turno',
          livemap: 'Mapa em tempo real',
        },
      },
      vehicles: {
        title: 'Veículos',
      },
      integrations: {
        title: 'Integrações',
      },
      automations: {
        title: 'Automações',
      },
      reports: {
        title: 'Relatórios',
      },
      more: {
        title: 'Mais',
        children: {
          areas: 'Zonas',
          attributes: 'Atributos',
          blacklist: 'Lista Negra de Cartões',
          extraServices: 'Serviços extras',
          fares: 'Tarifas',
          holidays: 'Feriados',
          locations: 'Localização',
          permissions: 'Funções e Permissões',
          profiles: 'Perfis',
          rates: 'Taxas',
          services: 'Serviços',
          shifts: 'Turnos',
          shuttles: 'Transporte',
          sites: 'Locais',
          suppliers: 'Fornecedores',
          settings: 'Configurações do sistema',
          uploadData: 'Carregar dados',
          users: 'Usuários',
          apiKeys: 'Chaves de API',
          customRules: 'Regras Personalizadas',
          facilities: 'Instalações',
          roiSimulation: 'Simulação de ROI',
        },
      },
    },
    settings: {
      myProfile: {
        button: 'Meu perfil',
      },
      languages: {
        button: 'Idiomas',
      },
      themes: {
        button: 'Alterar tema',
        options: {
          light: 'Light',
          dark: 'Dark',
        },
      },
      logout: 'Sair',
    },
  },

  footer: {
    poweredBy: 'Habilitado por',
    moovex: 'Moovex',
  },

  asideQueue: {
    headerQueue: 'Fila',
    empty: 'Nenhuma reserva na fila encontrada',
    btnRemove: 'Remover da fila',
    btnAssign: 'Mover para viagem',
  },
};

export default layout;
